import { useEffect, useState } from "react";
import Skeleton from "react-loading-skeleton";

import { Button } from "components/Buttons";
import { ButtonColorScheme } from "types/ui";
import { selectCurrentExam } from "store/ExamStore/selectors";
import {
  selectCurrentExamGroupDoubleKnee,
  selectCurrentExamGroupLeftKnee,
  selectCurrentExamGroupRightKnee,
} from "store/ExamGroupStore/selectors";
import { formatTimeFromUtc } from "utils/formatters";
import { useAppDispatch, useAppSelector } from "hooks/reduxHooks";
import { getExamGroup } from "store/ExamGroupStore/actions";
import { getExam } from "store/ExamStore/actions";
import { getMinAndMaxExamFrames } from "store/ExamMLResultStore/actions";

type Props = {
  loading?: boolean;
  jointId: string;
  setJointId: any;
};
let jointIdList = [
  { id: "62e190ff9f293b927973f92b", side: "Double knee drop" },
  { id: "624d97375ed2b030d38e4707", side: "Left knee drop" },
  { id: "624d97335ed2b030d38e4706", side: "Right knee drop" },
];
export const AthleteTopSection = ({ loading, jointId, setJointId }: Props) => {
  const dispatch = useAppDispatch();
  const exam = useAppSelector(selectCurrentExam);
  const examGroupDoubleKnee = useAppSelector(selectCurrentExamGroupDoubleKnee);
  const examGroupRightKnee = useAppSelector(selectCurrentExamGroupRightKnee);
  const examGroupLeftKnee = useAppSelector(selectCurrentExamGroupLeftKnee);

  const [currentJointId, setCurrentJointId] = useState<string>(jointId);
  const [groupLoading, setGroupLoading] = useState(false);

  function changeExam(currentJointId: any, _id: any) {
    setCurrentJointId(currentJointId);
    setJointId(currentJointId);
    dispatch(getExam(_id));
    dispatch(getMinAndMaxExamFrames(_id));
  }

  useEffect(() => {
    if (!window.location.pathname.includes(exam._id)) {
      return;
    }
    console.log("exam", exam);
    setGroupLoading(true);
    if (exam.examGroupId) {
      dispatch(
        getExamGroup(exam.examGroupId, false, () => {
          setGroupLoading(false);
        })
      );
    } else {
      dispatch(
        getExamGroup("", true, () => {
          setGroupLoading(false);
        })
      );
    }
  }, [exam]);

  console.log("examGroupDoubleKnee", examGroupDoubleKnee);
  return (
    <>
      <section className="flex flex-wrap items-center justify-between pb-3 border-b border-b-[#E1E1E1] justify-start">
        <div className="flex flex-row flex-[0_1_70%]">
          <h1 className="leading-[30px]">Video Review &nbsp;</h1>
          {loading ? (
            <>
              <Skeleton count={1} height={30} />
            </>
          ) : (
            <h2 className="text-xl self-center	 font-normal text-grayDark leading-[39px] capitalize">
              | {formatTimeFromUtc(exam.createdAt)}
            </h2>
          )}
        </div>
        {!groupLoading && (
          <div className="flex w-[382px] flex-wrap">
            {examGroupDoubleKnee.length > 0 && (
              <Button
                onClick={() => {
                  changeExam(jointIdList[0].id, examGroupDoubleKnee[0]._id);
                }}
                colorScheme={
                  currentJointId == jointIdList[0].id
                    ? ButtonColorScheme.dark
                    : ButtonColorScheme.default
                }
                title="Double knee drop"
                classNames="flex items-center decoration-[#5C5D69] h-[33px] rounded-[10px] pl-[10px] pr-[10px] mt-[5px] text-[14px] leading-[30px]"
              />
            )}
            {examGroupLeftKnee.length > 0 && (
              <Button
                onClick={() => {
                  changeExam(jointIdList[1].id, examGroupLeftKnee[0]._id);
                }}
                colorScheme={
                  currentJointId == jointIdList[1].id
                    ? ButtonColorScheme.dark
                    : ButtonColorScheme.default
                }
                title="Left knee drop"
                classNames="flex items-center decoration-[#5C5D69] h-[33px] rounded-[10px] pl-[10px] pr-[10px] mr-[6px] ml-[6px] mt-[5px] text-[14px] leading-[30px]"
              />
            )}
            {examGroupRightKnee.length > 0 && (
              <Button
                onClick={() => {
                  changeExam(jointIdList[2].id, examGroupRightKnee[0]._id);
                }}
                colorScheme={
                  currentJointId == jointIdList[2].id
                    ? ButtonColorScheme.dark
                    : ButtonColorScheme.default
                }
                title="Right knee drop"
                classNames="flex items-center decoration-[#5C5D69] h-[33px] rounded-[10px] pl-[10px] pr-[10px] mt-[5px] text-[14px] leading-[30px]"
              />
            )}
          </div>
        )}
      </section>
    </>
  );
};
